// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eqia","right":"styles_right__3WucH"};